"use strict";

angular.module("internal.exams").controller("InternalExamAutoNumber", [
    "$scope",
    "$stateParams",
    "$state",
    "EXAutoNum",
    "$window",
    function (
        $scope,
        $stateParams,
        $state,
        EXAutoNum,
        $window
    ) {
        $scope.AutoNum = {};
        $scope.editHistory = {};
        $scope.saveMessage = $stateParams.saveMessage;
        $window.scrollTo(0, 0);

        if ($stateParams.examAutoNumID != null) {
            EXAutoNum.getautonum($stateParams.examAutoNumID).then(function (AutoNum) {
                $scope.editHistory = {
                    createdby: AutoNum.createdByFullName,
                    modifiedby: AutoNum.modifiedByFullName,
                    createdon: AutoNum.createdOnUtc,
                    modifiedon: AutoNum.modifiedOnUtc
                };
                $scope.AutoNum = AutoNum;
            });
        }

        $scope.save = function () {
            $scope.saving = true;
            $scope.AutoNum.active = true;
            EXAutoNum.save($scope.AutoNum).then(function (AutoNum) {
                $scope.saving = false;
                if (AutoNum != null) {
                    $state.go("internal.exams.administrative.autonumber", { examAutoNumID: AutoNum.id, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };

        $scope.routeExamType = function (examTypeId) {
            var url = $state.href("internal.exams.administrative.type", { examTypeID: examTypeId });
            window.open(url, '_blank');
        };

        $scope.delete = function () {
            $scope.deleting = true;
            if ($scope.AutoNum.numOfTypes != null && $scope.AutoNum.numOfTypes > 0) {
                $scope.saveMessage = "Please re-assign the associated exam type(s) to a different Auto Number in order for deletion.";
                $window.scrollTo(0, 0);
                $scope.deleting = false;
            } else {
                if (window.confirm("Are you sure you want to delete this auto number?")) {
                    EXAutoNum.delete($scope.AutoNum.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.autonumbers", {}, { reload: "internal.exams.administrative.autonumbers" });
                    });
                } else {
                    $scope.deleting = false;
                }
                $scope.deleting = false;
            }
        };

        $scope.FormatNumber = function (number, rule) {
            if (rule == null) return number;
            var size = rule.length;

            var s = number + "";
            while (s.length < size) s = "0" + s;
            return s;
        };

        $scope.FormatDate = function (dateFormat) {
            var format = dateFormat;

            if (format == "none") {
                format = null;
            } else if (format == "yymm") {
                format = "yyMM";
            } else if (format == "yymmdd") {
                format = "yyMMdd";
            } else if (format == "yyyymmdd") {
                format = "yyyyMMdd";
            }

            return format;
        };

        $scope.Date = function () {
            return new Date();
        };

        $scope.dateFormats = [
            { name: "none", id: null },
            { name: "yy", id: "yy" },
            { name: "yyyy", id: "yyyy" },
            { name: "yymm", id: "yymm" },
            { name: "yymmdd", id: "yymmdd" },
            { name: "yyyymmdd", id: "yyyymmdd" }
        ];
        $scope.ruleFormats = [
            { name: "XXX", id: "XXX" },
            { name: "XXXX", id: "XXXX" },
            { name: "XXXXX", id: "XXXXX" },
            { name: "XXXXXX", id: "XXXXXX" },
            { name: "XXXXXXX", id: "XXXXXXX" },
            { name: "XXXXXXXX", id: "XXXXXXXX" },
            { name: "XXXXXXXXX", id: "XXXXXXXXX" },
            { name: "XXXXXXXXXX", id: "XXXXXXXXXX" },
            { name: "XXXXXXXXXXX", id: "XXXXXXXXXXX" }
        ];
    }
]);
